import { swanbot_URL as SWANBOT_URL } from './api.js';

const DATAEXPLORER_MAX_SESSIONS_REDIRECT_DEFAULT = false;

function resolveSwanbotUrlFromStateDom() {
  const hiddenInput = document.getElementById('dataexplorer_swanbot_url');
  if (hiddenInput && typeof hiddenInput.value === 'string' && hiddenInput.value.trim() !== '') {
    return hiddenInput.value.trim();
  }

  return SWANBOT_URL;
}

function parseStateBoolean(value, fallback) {
  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value !== 'string') {
    return fallback;
  }

  const normalizedValue = value.trim().toLowerCase();

  if (['true', '1', 'yes', 'on'].includes(normalizedValue)) {
    return true;
  }

  if (['false', '0', 'no', 'off'].includes(normalizedValue)) {
    return false;
  }

  return fallback;
}

function resolveDataExplorerMaxSessionsRedirectFromStateDom() {
  const hiddenInput = document.getElementById('dataexplorer_max_sessions_redirect');

  if (hiddenInput && typeof hiddenInput.value === 'string' && hiddenInput.value.trim() !== '') {
    return parseStateBoolean(hiddenInput.value, DATAEXPLORER_MAX_SESSIONS_REDIRECT_DEFAULT);
  }

  return DATAEXPLORER_MAX_SESSIONS_REDIRECT_DEFAULT;
}

function resolveSwanbotRelayEnabledFromStateDom() {
  const hiddenInput = document.getElementById('swanbot_relay_enabled');
  return hiddenInput
    ? parseStateBoolean(hiddenInput.value, false)
    : false;
}

function resolveSwanbotRelayUrlFromStateDom() {
  const hiddenInput = document.getElementById('swanbot_relay_url');
  return hiddenInput && typeof hiddenInput.value === 'string'
    ? hiddenInput.value.trim().replace(/\/+$/, '')
    : '';
}

export const state = {
  customer_events: null,
  eventcalendarObj: null,
  explorercalendarObj: null,
  tooltip: null,
  tooltiptimer: null,
  args_handle: null,
  digest_events: null,
  change_filter_handler: "",
  dashboard_monitor: null,

  swanbot_dataexplorer_graph_id: "",
  swanbot_dataexplorer_graphs: [],
  swanbot_dataexplorer_graphdata: { "graphs": [], "graphs_compare": "", "filters": [], "output": "", "maingraphTitles": [], "maingraphIndex": {}, "subgraphGroupData": [], "subgraphs_compare": "", "subgraphGroupTitles": [], "subgraphGroupIndex": {}, "subgraphGroupDimensions": "", "focus": {}, "axis_types": {} },

  swanbot_dataexplorer_processing_compare_type: "",
  swanbot_dataexplorer_filter_subgrouping: "",
  loaded_events: false,
  loading_events: false,
  de_loading_events: false,
  active_event_track: 0,
  get_date_range: 3,
  calStartDay: 5,
  calEndDay: 1,
  calType: "day",
  actionid: 111,
  customerid: "",
  monitor_dashboard_timer: 60000,
  dashboard_monitor_running: false,
  swanbot_URL: resolveSwanbotUrlFromStateDom(),
  swanbot_relay_enabled: resolveSwanbotRelayEnabledFromStateDom(),
  swanbot_relay_url: resolveSwanbotRelayUrlFromStateDom(),
  swanbot_url_called: false,
  dataexplorer_max_sessions_redirect: resolveDataExplorerMaxSessionsRedirectFromStateDom(),
  swanbot_init: false,
  swanbot_key: "",
  swanbot_session: "",
  swanbot_dataexplorer_session: "",
  // Add other simple state defaults here as needed over time
};

//'http://localhost:4444/',

export function updateState(key, value) {
  state[key] = value;
}

export function markSwanbotUrlCalled() {
  state.swanbot_url_called = true;
  return state.swanbot_url_called;
}

export function syncSwanbotUrlState() {
  state.swanbot_URL = resolveSwanbotUrlFromStateDom();
  state.swanbot_relay_enabled = resolveSwanbotRelayEnabledFromStateDom();
  state.swanbot_relay_url = resolveSwanbotRelayUrlFromStateDom();
  return state.swanbot_URL;
}

export function syncDataExplorerMaxSessionsRedirectState() {
  state.dataexplorer_max_sessions_redirect = resolveDataExplorerMaxSessionsRedirectFromStateDom();
  return state.dataexplorer_max_sessions_redirect;
}

export function syncServerRenderedState() {
  syncSwanbotUrlState();
  syncDataExplorerMaxSessionsRedirectState();
  return state;
}
